module.exports = __webpack_public_path__ + "static/media/logo_short__color.8d301d3f.svg";